import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true,
  },
  {
    id: 37,
    label: 'CTC',
    icon: 'bx-user',
    permissionRequired: 'show.CTC',
    subItems: [
      {
        id: 38,
        label: 'Clasificación',
        link: '/ctc/client-classification',
        parentId: 37,
        permissionRequired: 'show.clasification',
      },
      {
        id: 45,
        label: 'Matriz de clientes',
        link: '/ctc/customer-matrix',
        parentId: 37,
        permissionRequired: 'show.customerMatrix',
      },
      {
        id: 52,
        label: 'Datos de contacto',
        link: '/ctc/customer-contact-information',
        parentId: 37,
        permissionRequired: 'show.customerContactInformation',
      }
    ]
  },
  {
    id: 39,
    label: 'Notificaciones',
    icon: 'bx-message',
    permissionRequired: 'show.Notifications',
    subItems: [
      {
        id: 40,
        label: 'WhatsApp',
        link: '/notifications/whatsapp',
        parentId: 39,
        permissionRequired: 'show.NotificationsWhatsApp',
      }, {
        id: 51,
        label: 'Push',
        link: '/notifications/pushNotifications',
        parent: 39,
        permissionRequired: 'show.pushNotifications'

      }
    ]
  },
  {
    id: 3,
    label: 'Generador Ref.',
    icon: 'bx-barcode',
    permissionRequired: 'show.GeneradorReferencia',
    subItems: [
      {
        id: 4,
        label: 'Nueva referencia',
        link: '/reference/new',
        parentId: 3
      }
    ]
  },
  {
    id: 5,
    label: 'Solicitudes de crédito',
    icon: 'bx-file',
    permissionRequired: 'show.SolicitudesCredito',
    subItems: [
      {
        id: 30,
        label: 'Portal',
        link: '/source-portal/list',
        parentId: 5,
        permissionRequired: 'show.ListProspectsPortal'
      },
      {
        id: 55,
        label: 'Whitelist',
        link: '/source-portal/white-list',
        parentId: 5,
        permissionRequired: 'show.whiteListPortal'
      },
      {
        id: 6,
        label: 'Listado',
        link: '/credit-request/list',
        parentId: 5
      },
    ]
  },
  {
    id: 12,
    label: 'Mesa control',
    icon: 'bx-list-check',
    permissionRequired: 'show.SolicitudesMesaControl',
    subItems: [
      {
        id: 34,
        label: 'Adm. Cuentas bancarias',
        icon: 'bx-list-check',
        link: '/bank-account-management/list',
        permissionRequired: 'show.bankAccountManagament',
        parentId: 12
      },
      {
        id: 13,
        label: 'Solicitudes de crédito',
        icon: 'bx-list-check',
        link: '/prospect/listTableControl',
        parentId: 12
      },
      {
        id: 23,
        label: 'Solicitudes canceladas',
        icon: 'bx-list-check',
        link: '/prospect/cancelled-credit-applications',
        parentId: 12
      },
      {
        id: 27,
        label: 'Solicitudes de dispersión',
        icon: 'bx-list-check',
        link: '/dispersions-requests/list',
        parentId: 12
      },
    ]
  },
  {
    id: 31,
    label: 'Visita Fisíca',
    icon: 'bx-user-voice',
    permissionRequired: 'show.physicalVisit',
    subItems: [
      {
        id: 32,
        label: 'Catálogos',
        link: '/physical-visit/catalogs',
        permissionRequired: 'show.PhysicalVisitCatalog',
        parentId: 31
      },
      {
        id: 33,
        label: 'Torre de Control',
        link: '/physical-visit/control-tower',
        permissionRequired: 'show.PhysicalVisitControlTower',
        parentId: 31
      }
    ]
  },
  {
    id: 14,
    label: 'Asesores en sucursal',
    icon: 'bx-map',
    permissionRequired: 'show.AsesoresEnSucursal',
    subItems: [
      {
        id: 13,
        label: 'Monitor de ubicaciones',
        link: '/maps/users-locations',
        // parentId: 14
      }
    ]
  },
  {
    id: 18,
    label: 'Gestión de cartera',
    icon: 'bx-wallet-alt',
    permissionRequired: 'show.GestionCartera',
    subItems: [
      {
        id: 19,
        label: 'Administración de gestores',
        link: '/manager/list',
        parentId: 18,
        permissionRequired: 'show.AdminGestores'
      },
      {
        id: 22,
        label: 'Administración de gerentes',
        link: '/portfolio-management/list-managers',
        parentId: 18,
        permissionRequired: 'show.AdminGerentes'
      },
      {
        id: 20,
        label: 'Administración de promotores',
        link: '/portfolio-management/list-promoters',
        parentId: 18,
        permissionRequired: 'show.AdminPromotores'
      },
      {
        id: 21,
        label: 'Administración de cartera',
        link: '/portfolio-management/list-credits',
        parentId: 18,
        permissionRequired: 'show.AdminCartera'
      },
      {
        id: 34,
        label: 'Mi cartera promotor',
        link: '/portfolio-management/my-portfolio-promoter',
        parentId: 18,
        permissionRequired: 'show.MyPortfolio'
      },
      {
        id: 35,
        label: 'Mi cartera gestor',
        link: '/portfolio-management/my-portfolio-manager',
        parentId: 18,
        permissionRequired: 'show.MyPortfolioManager'
      },
      {
        id: 36,
        label: 'Mi cartera gerente',
        link: '/portfolio-management/my-portfolio-business-manager',
        parentId: 18,
        permissionRequired: 'show.MyPortfolioBusinessManager'
      },
      {
        id: 53,
        label: 'Gestión cobranza',
        link: '/portfolio-management/collection-management',
        parentId: 18,
        permissionRequired: 'show.CollectionManagement'
      }
    ]
  },
  {
    id: 60,
    label: 'Agenda',
    icon: 'bx-calendar',
    permissionRequired: 'show.AgendaModule',
    subItems: [
      {
        id: 61,
        label: 'Agenda del día',
        link: '/agenda-board/agenda-of-the-day',
        parentId: 60,
        permissionRequired: 'show.AgendaOfTheDay',
      },
      {
        id: 62,
        label: 'Medidores',
        link: '/agenda-board/agenda-meters',
        parentId: 60,
        permissionRequired: 'show.AgendaMeters',
      }
    ]
  },
  {
    id: 24,
    label: 'Dispersiones',
    icon: 'bx-money',
    permissionRequired: 'show.DispersionesModule',
    subItems: [
      {
        id: 25,
        label: 'Dispersiones de crédito',
        link: '/dispersions-board/list',
        parentId: 7,
        permissionRequired: 'show.DispersionesLista',
      }
    ]
  },
  {
    id: 41,
    label: 'PaSe',
    icon: 'bx-broadcast',
    permissionRequired: 'show.PaSe',
    subItems: [
      {
        id: 42,
        label: 'Catálogo de Servicios',
        link: '/pase/service-catalog',
        parentId: 41,
        permissionRequired: 'show.PaSeServicesCatalog'
      },
      {
        id: 50,
        label: 'Transacciones',
        link: '/pase/transaction-report',
        parentId: 41,
        permissionRequired: 'show.PaSeTransactionReport'
      }
    ]
  },
  {
    id: 28,
    label: 'Sociales',
    icon: 'bx-laptop',
    permissionRequired: 'show.SocialesWeb',
    subItems: [
      {
        id: 27,
        label: 'Listado prospecto',
        link: '/portal/listCreditoPortal',
        parentId: 28,
        permissionRequired: 'show.ListadoProspectoWeb'
      },
      {
        id: 26,
        label: 'Listado contacto portal',
        link: '/portal/listProspectoPortal',
        parentId: 28,
        permissionRequired: 'show.ListadoContacto'
      },
      {
        id: 28,
        label: 'Administrador Blog',
        link: '/portal/Blog',
        parentId: 28,
        permissionRequired: 'show.AdminitsradorBlog'
      }
    ]
  },
  {
    id: 29,
    label: 'Dashboards',
    icon: 'bxs-dashboard',
    permissionRequired: 'show.Dashboards',
    subItems: [{
      id: 3,
      label: 'Directivo',
      link: '/dashboards/executive-board',
      parentId: 29,
      permissionRequired: 'show.ExecutiveBoard'
    }]
  },
  {
    id: 9,
    label: 'Roles y permisos',
    icon: 'bx-lock',
    permissionRequired: 'show.RolesPermisos',
    subItems: [
      {
        id: 10,
        label: 'Módulos',
        link: '/identity/modules',
        parentId: 9,
        permissionRequired: 'show.Modulos'
      },
      {
        id: 11,
        label: 'Permisos',
        link: '/identity/permissions',
        parentId: 9,
        permissionRequired: 'show.Permisos'
      },
      {
        id: 12,
        label: 'Roles',
        link: '/identity/roles',
        parentId: 9,
        permissionRequired: 'show.Roles'
      },
      {
        id: 13,
        label: 'Usuarios y roles',
        link: '/identity/users-roles',
        parentId: 9,
        permissionRequired: 'show.UsuariosRoles'
      },
    ]
  },
  {
    id: 43,
    label: 'El zorro',
    icon: 'bxl-firefox',
    permissionRequired: 'show.Fox',
    subItems: [{
      id: 44,
      label: 'Reporte de pagos',
      link: '/fox/payment-report',
      parentId: 43,
      permissionRequired: 'show.FoxPayments'
    }, {
      id: 46,
      label: 'Resumen histórico',
      link: '/fox/pivot-payment-report',
      parentId: 43,
      permissionRequired: 'show.FoxPivotPayments'
    },
    {
      id: 47,
      label: 'Reporte de comisiones',
      link: '/fox/commissions-report',
      parentId: 43,
      permissionRequired: 'show.FoxCommissionsReport'
    }, {
      id: 48,
      label: 'Tokens',
      link: '/fox/tokens',
      parentId: 43,
      permissionRequired: 'show.FoxTokens'
    }, {
      id: 49,
      label: 'Sucursales',
      link: '/fox/branches',
      parentId: 43,
      permissionRequired: 'show.FoxBranches'
    }]
  }
];
